import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../theme/colors';

export const useEntityHistoryChangeStyles = makeStyles({
  wrapper: {
    padding: '4px 0',
    fontSize: '13px',
    // Whole words move to the next line first; only a word longer than the line itself is split.
    overflowWrap: 'break-word'
  },
  // The space after each piece is text, so the margins only top it up to the old gap.
  label: {
    color: Colors.midGray,
    fontWeight: 500,
    marginRight: '2px'
  },
  type: {
    fontSize: '11px',
    fontWeight: 600,
    textTransform: 'uppercase',
    borderRadius: '3px',
    padding: '1px 6px',
    marginRight: '2px'
  },
  typeAdded: {
    color: Colors.collectedGreen,
    backgroundColor: 'rgba(52, 174, 167, 0.1)'
  },
  typeUpdated: {
    color: Colors.deliveredBlue,
    backgroundColor: 'rgba(32, 112, 199, 0.1)'
  },
  typeDeleted: {
    color: Colors.cancelledDeletedRed,
    backgroundColor: 'rgba(219, 46, 45, 0.1)'
  },
  values: {
    color: Colors.darkGray
  },
  previousValue: {
    textDecoration: 'line-through',
    color: Colors.midGray
  },
  arrow: {
    color: Colors.midGray,
    fontSize: '12px'
  },
  newValue: {
    fontWeight: 500
  }
});
